import React from 'react';
import { ThumbFrame, INK } from './thumbFrame';

/** NLP API — natural language tokenized and returned as a structured response. */
const NlpApiThumb: React.FC = () => (
  <ThumbFrame label="Natural Language Processing API">
    {/* Language bubble with tokens */}
    <rect x="40" y="92" width="150" height="116" rx="14" fill="#ffffff" stroke={INK} strokeWidth="1.8" />
    <path d="M70 208 l0 22 l24 -22 Z" fill="#ffffff" stroke={INK} strokeWidth="1.8" />
    {[
      { x: 58, y: 116, w: 40 },
      { x: 104, y: 116, w: 30 },
      { x: 58, y: 140, w: 24 },
      { x: 88, y: 140, w: 46 },
      { x: 140, y: 140, w: 20 },
      { x: 58, y: 164, w: 52 },
    ].map((tk, i) => (
      <rect key={i} x={tk.x} y={tk.y} width={tk.w} height="15" rx="7.5" fill={INK} opacity={0.16}>
        <animate attributeName="opacity" values="0.16;0.7;0.16" dur="2.4s" begin={`${i * 0.25}s`} repeatCount="indefinite" />
      </rect>
    ))}

    {/* Arrow */}
    <path d="M200 150 H228 M220 141 l10 9 l-10 9" fill="none" stroke={INK} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />

    {/* JSON response card */}
    <rect x="242" y="92" width="118" height="116" rx="12" fill={INK} />
    <text x="256" y="120" fontFamily="'JetBrains Mono', monospace" fontSize="16" fill="#ffffff">{'{'}</text>
    <rect x="272" y="128" width="52" height="6" rx="3" fill="#ffffff" opacity="0.85" />
    <rect x="272" y="142" width="66" height="6" rx="3" fill="#ffffff" opacity="0.55" />
    <rect x="272" y="156" width="44" height="6" rx="3" fill="#ffffff" opacity="0.55" />
    <rect x="272" y="170" width="58" height="6" rx="3" fill="#ffffff" opacity="0.55" />
    <text x="256" y="196" fontFamily="'JetBrains Mono', monospace" fontSize="16" fill="#ffffff">{'}'}</text>
  </ThumbFrame>
);

export default NlpApiThumb;
